import React from 'react';
import Button from './ui/Button';

const FooterCTA = () => {
  return (
    <section className="py-24 bg-olive-grove text-vintage-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(#F6F1E8 1px, transparent 1px)', backgroundSize: '30px 30px' }}></div>
      
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center relative z-10">
        <h2 className="text-4xl md:text-5xl font-serif mb-8">
          See If Padua Is the Right Setting for Your Wedding
        </h2>
        <p className="text-lg text-vintage-white/90 font-light leading-relaxed max-w-2xl mx-auto mb-10">
          The best way to understand Padua Weddings is to experience the setting in person. During your private tour, you can walk the ceremony and reception spaces, discuss your guest count and preferred date, and receive guidance on your starting estimate.
        </p>
        <Button 
          href="https://tour.paduaweddings.com" 
          className="bg-[#FCFAF6] text-[#2F2B28] border border-[#A67C52] hover:bg-[#A67C52] hover:text-[#FCFAF6] transition-all duration-300 shadow-xl"
        >
          Schedule Your Private Tour
        </Button>
      </div>
    </section>
  );
};

export default FooterCTA;